import React from 'react';
import { Box } from '@mui/material';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import WifiIcon from '@mui/icons-material/Wifi';
import BatteryFullIcon from '@mui/icons-material/BatteryFull';

const BASE_WIDTH = 320;
const BASE_HEIGHT = 660;

/**
 * iPhone-like bezel. The device is always built at its natural 320x660 size and
 * scaled with a CSS transform, so everything inside (the mock app, the push
 * card) shrinks with it — children do not need to know about `scale`. The outer
 * box still occupies the scaled size in the layout, and carries the tilt.
 */
export default function PhoneFrame({ children, scale = 1, tilt = 0, showStatusBar = true, time = '9:41', sx = {} }) {
    return (
        <Box
            sx={{
                width: BASE_WIDTH * scale,
                height: BASE_HEIGHT * scale,
                flex: 'none',
                transform: tilt ? `rotate(${tilt}deg)` : 'none',
                ...sx
            }}
        >
            <Box
                sx={{
                    width: BASE_WIDTH,
                    height: BASE_HEIGHT,
                    transform: `scale(${scale})`,
                    transformOrigin: 'top left',
                    borderRadius: '44px',
                    p: '8px',
                    backgroundColor: '#0A0A0A',
                    boxShadow: '0 20px 50px rgba(0,0,0,0.25), 0 6px 20px rgba(0,0,0,0.12), inset 0 0 0 2px #1f1f1f',
                    position: 'relative',
                    boxSizing: 'border-box'
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '36px',
                        backgroundColor: '#fff',
                        overflow: 'hidden',
                        position: 'relative'
                    }}
                >
                    {showStatusBar && (
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                px: '22px',
                                pt: '10px',
                                fontWeight: 600,
                                fontSize: 13,
                                zIndex: 5
                            }}
                        >
                            <Box component="span">{time}</Box>

                            <Box
                                sx={{
                                    position: 'absolute',
                                    left: '50%',
                                    top: 6,
                                    transform: 'translateX(-50%)',
                                    width: 90,
                                    height: 26,
                                    backgroundColor: '#0A0A0A',
                                    borderRadius: '14px'
                                }}
                            />

                            <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center', '& svg': { fontSize: 14 } }}>
                                <SignalCellularAltIcon />
                                <WifiIcon />
                                <BatteryFullIcon />
                            </Box>
                        </Box>
                    )}

                    <Box sx={{ position: 'absolute', inset: 0, pt: showStatusBar ? '44px' : 0 }}>
                        {children}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
